import { ComponentType } from "react";
import { EventDataTypeEnum, WorkTypeEnum } from "../../../store/types/work.types";
import { WorkTypeComponentProps } from "./WorkTypeComponentProps";
import SecureVolumeDetails from "./secure-volume/SecureVolumeDetails";

export interface WorkTypeRegistryEntry {
  component: ComponentType<WorkTypeComponentProps>;
  tabLabel: string;
  hiddenEventTypes?: EventDataTypeEnum[];
}

const workTypeRegistry: Partial<
  Record<WorkTypeEnum, WorkTypeRegistryEntry>
> = {
  [WorkTypeEnum.SecureVolume]: {
    component: SecureVolumeDetails,
    tabLabel: "Säkrad Volym",
    hiddenEventTypes: [EventDataTypeEnum.SecureVolume],
  },
};

export default workTypeRegistry;
